import apiClient from '../service/api'

// GET Projects
export const getProjects = async (page) => {
  const { data } = await apiClient.get('/v1/projects', {
    params: { page },
  })

  return data
}

// GET Project
export const getProject = async (projectId) => {
  const { data } = await apiClient.get(`/v1/projects/${projectId}`)
  return data
}

// CREATE Project
// export const createProject = async () => {
//   const token = localStorage.getItem('token')

//   const { data } = await apiClient.post(``)
// }
